import gql from 'graphql-tag';

export default gql`
  fragment FlowActionContactAddTagFields on Flow_Action_Contact_AddTag {
    __typename
    id
    accountId
    flowBlueprintId
    parentId
    name {
      __typename
      value
    }
  }
`;
